import { FC } from 'react';
import { CircularProgress, IconButton, Tooltip } from '@mui/material';
import SendAndArchiveTwoToneIcon from '@mui/icons-material/SendAndArchiveTwoTone';
import { useTypedSelector } from 'src/hooks/useTypeSelector';
import { useActions } from 'src/hooks/useActions';
import './styles.scss';

interface IProps {
  title: string;
  subtitle: string;
  name?: string;
  id: number;
  isDisabled: boolean;
  isAdmin?: boolean;
  onOpenModal?: () => void;
}

const IconActionItem: FC<IProps> = ({
  title,
  subtitle,
  name,
  id,
  isDisabled,
  isAdmin,
  onOpenModal
}) => {
  const { actionOrder } = useActions();
  const { role } = useTypedSelector(state => state.auth);
  const { isLoading } = useTypedSelector(state => state.order);

  return (
    <div
      className={`order-notification__list__item action ${role !== 'admin' && isAdmin && 'hidden'}`}
    >
      <div className='action__title'>
        <b>
          {title}
          {subtitle.length ? ':' : ''}{' '}
        </b>
        <span>{subtitle}</span>
      </div>
      <div className='order-notification__action'>
        <div className='order-notification__action__item action__icon'>
          {isLoading.action ? (
            <CircularProgress size={15} />
          ) : (
            <Tooltip title={title}>
              <IconButton
                onClick={onOpenModal ? () => onOpenModal() : () => actionOrder(id, name!)}
                disabled={isDisabled}
              >
                <SendAndArchiveTwoToneIcon sx={{ fill: 'rgb(0, 127, 255)', fontSize: '2rem' }} />
              </IconButton>
            </Tooltip>
          )}
        </div>
      </div>
    </div>
  );
};

export default IconActionItem;
